module.exports = __webpack_public_path__ + "img/erc.b6d5c8e5.svg";